import { useOFetchCustom } from "~/composables/useOFetchCustom"
import type { Category } from "~/models/Category"

export const useCategoriesStore = defineStore("categories", {
    state: (): {
        categories: Category[]
        currentCategorySelected: string | null
        categoriesByStore: Category[]
        loadingCategories: boolean
        loadingCategoriesByStore: boolean
    } => ({
        categories: [],
        currentCategorySelected: null,
        categoriesByStore: [],
        loadingCategories: false,
        loadingCategoriesByStore: false
    }),
    actions: {
        setCategories(categories: Category[]) {
            this.categories = categories
        },
        setCategoriesByStore(categories: Category[]) {
            this.categoriesByStore = categories
        },
        setCurrentCategorySelected(category: string) {
            this.currentCategorySelected = category
        },
        getCategories() {
            if (this.categories.length === 0) {
                this.fetchCategories()
            }
        },
        fetchCategories() {
            this.loadingCategories = true
            const { get } = useOFetchCustom("public/categories")
            get(undefined, {
                onSuccess: ({ data }) => {
                    this.setCategories(data)

                    if(this.categoriesByStore.length === 0){
                        this.setCategoriesByStore(data)
                    }
                },
                onError: (error: any) => {
                    console.log(error)
                },
                onFinish: () => {
                    this.loadingCategories = false
                }
            })
        },
        getCategoriesByStore(store: string | undefined) {
            this.loadingCategoriesByStore = true
            if(!store){
                this.setCategoriesByStore(this.categories)
                this.loadingCategoriesByStore = false
            }else if (this.categoriesByStore.length === 0) {
                this.fetchCategoriesByStore(store)
            } else {
                this.loadingCategoriesByStore = false
            }
        },
        fetchCategoriesByStore(store: string | undefined) {
            this.loadingCategoriesByStore = true
            if (!store){
                this.setCategoriesByStore(this.categories)
                this.loadingCategoriesByStore = false
            }else {
                const { get } = useOFetchCustom(
                    `public/${store}/categories`
                )
                get(undefined, {
                    onSuccess: ({ data }) => {
                        this.setCategoriesByStore(data)
                    },
                    onError: (error: any) => {
                        console.log(error)
                    },
                    onFinish: () => {
                        this.loadingCategoriesByStore = false
                    }
                })
            }
        },
        findCategoryByName(name: string) {
            return (
                this.categories.find((category) => category.label === name) ||
                null
            )
        },
    },
})
